import { render, staticRenderFns } from "./RecuperationDiv.vue?vue&type=template&id=2836a2b6&"
import script from "./RecuperationDiv.vue?vue&type=script&lang=ts&"
export * from "./RecuperationDiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports